import { useEffect, useRef } from "react";
import {createApiCall} from "../api/api-service"

export default function useVisitorTracking() {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current) return; // prevents multiple API calls
    hasTracked.current = true;

    const trackVisitor = async () => {
      try {
        // Ask backend to create or recognize visitor cookie
          // await fetch("http://localhost:4000/api/tracking/tracking-info", {
          //   method: "GET",
          //   credentials: "include", // important: allows cookie to be stored
          // });
          await createApiCall("GET","tracking/tracking-info",{},false,undefined,true)
        
      } catch (err) {
        console.error("Visitor tracking failed:", err);
      }
    };

    trackVisitor();
  }, []);
}
